// extracted by mini-css-extract-plugin
module.exports = {"item":"styles_item__ADwvB","star":"styles_star__a1w7_","star_wrapper":"styles_star_wrapper___ov0E"};